module.exports = __webpack_public_path__ + "static/box-2_3mb-e3090e0580ea0f31defb3c234ec531fc.mp4";